<div class="section start">
    <div class="container">
        <h3>API Settings</h3>
        <p class="translucent">You need an API access token to access and get data from Strayos Netra's API's. Read more
            about Strayos API's in our documentation</p>
        <hr>
        <div class="api-token container">
            <h4>Auth Token</h4>
            <div *ngIf="token$|async">
                <strong>{{tokenName$|async}} : </strong>{{token$|async}}
                <mat-icon class="list-icons" (click)="copyToken('auth')" matTooltip="copy"
                    [matTooltipPosition]="'above'">copy</mat-icon>
                <mat-icon class="list-icons" (click)="deleteToken()" matTooltip="remove"
                    [matTooltipPosition]="'above'">delete</mat-icon>
            </div>
            <div class="container">
                <mat-form-field>
                    <input matInput type="text" [(ngModel)]="newTokenName" />
                    <mat-label>New Token's Name</mat-label>
                </mat-form-field>
                <p *ngIf="error" class="error">please enter name for new token
                <p>
                    <button mat-button color="primary" (click)="getToken()">Generate new Token</button>
            </div>
        </div>
        <div class="api-token container">
            <h4>Sites Token</h4>
            <div *ngFor="let site of sites$ | async">
                <div class="api-token container">
                    <strong>{{site.name}} Token : </strong>{{site.token}}
                    <mat-icon class="list-icons" (click)="copyToken('site', site.token)" matTooltip="copy"
                        [matTooltipPosition]="'above'">copy</mat-icon>
                    <div class="container">
                        <p>
                            <button mat-button color="primary" (click)="generateSiteIntegrationToken(site)">Generate new
                                Token</button>
                        </p>
                    </div>
                </div>
            </div>
            <div *ngIf="(sites$ | async) === null" class="container centered-content">
                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
            </div>
        </div>
    </div>
</div>